<app-navbar></app-navbar>

<div class="min-h-screen bg-section pt-24 pb-20 px-4 sm:px-6 lg:px-8 font-serif text-body-text selection:bg-btn/30 relative overflow-hidden">
  
  <!-- Botanical Decoration -->
  <div class="absolute -bottom-10 -right-10 w-96 h-96 opacity-20 pointer-events-none z-0">
    <img src="amla-bottom-right.png" alt="" class="w-full h-full object-contain mix-blend-multiply rotate-12">
  </div>

  <div class="max-w-3xl mx-auto relative z-10 space-y-16">
    
    <!-- Header -->
    <div class="text-center space-y-4 animate-fade-in">
      <h1 class="text-5xl font-serif text-heading">Apothecary Wisdom</h1>
      <div class="w-24 h-px bg-btn mx-auto opacity-50"></div>
      <p class="text-muted font-serif italic text-lg mt-4">"Seeking clarity for your botanical journey? Find answers to frequently asked questions here."</p>
    </div>

    <!-- FAQ Accordion -->
    <div class="space-y-4 animate-fade-in-up">
      <div *ngFor="let faq of faqs; let i = index" class="bg-white border border-[#E5DDD5] rounded-sm overflow-hidden transition-all duration-300 shadow-sm" [class.shadow-md]="faq.isOpen">
        <button 
          (click)="toggleFaq(i)"
          class="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-section transition-colors"
        >
          <span class="text-lg font-serif text-heading pr-8">{{ faq.question }}</span>
          <span class="flex-shrink-0 text-btn transition-transform duration-500" [class.rotate-180]="faq.isOpen">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </span>
        </button>
        
        <div 
          class="overflow-hidden transition-all duration-500"
          [style.maxHeight]="faq.isOpen ? '500px' : '0px'"
        >
          <div class="px-6 pb-6 text-body-text leading-relaxed opacity-90 italic">
            "{{ faq.answer }}"
          </div>
        </div>
      </div>
    </div>

    <div class="text-center pt-10 animate-fade-in space-y-4">
      <p class="text-sm text-muted uppercase tracking-widest mb-6 font-bold opacity-60">Still have a question?</p>
      <div class="flex flex-col sm:flex-row justify-center gap-4">
        <a href="mailto:aarvyanaturals@gmail.com" class="inline-flex items-center justify-center gap-3 px-8 py-3 bg-heading text-white hover:bg-heading-dark transition-all font-serif uppercase text-[10px] tracking-widest rounded-sm">
          <span>Mail our Alchemists</span>
        </a>
        <a href="https://wa.me/919909149906" target="_blank" class="inline-flex items-center justify-center gap-3 px-8 py-3 border border-heading text-heading hover:bg-heading hover:text-white transition-all font-serif uppercase text-[10px] tracking-widest rounded-sm">
          <span>Connect via WhatsApp</span>
        </a>
      </div>
    </div>

  </div>
</div>
